import React from "react";
import { Router } from "@reach/router";
import labels from "./helpers/labels.json";
import DashboardScreens from "./components/pages/DashboardScreens";
import NotFoundPage from "./components/pages/NotFoundPage";
import LoginPath from "./components/pages/LoginPage/LoginPath";
import LoginPage from "./components/pages/LoginPage/index";
import CreateEventManager from "./components/internal/CreateEventManager/index";
import EventManagerRoute from "./components/pages/TemporatyRoute/index";
import ModifyEventManager from "./components/pages/ModifyEventManager";
import DashBoardRoute from "./components/pages/TemporatyRoute/index";
import EventHostRoute from "./components/pages/TemporatyRoute/index";
import EventsRoute from "./components/pages/TemporatyRoute/index";
import AnalyticsRoute from "./components/pages/TemporatyRoute/index";
import MyDashboard from "./components/internal/MyDashboard/index";
import EventHostTable from "./components/internal/EventHostTable";
import UpdateEventManager from "./components/internal/UpdateEventManager";
// import OrganisationRoute from "./components/pages/TemporatyRoute/index";
import CreateOrganisation from "./components/internal/Organisation/CreateOrganisation";
import OrganisationTable from "./components/pages/OrganizationTable/index";
import UpdateOrganization from "./components/pages/UpdateOrganizationPage";
// import TemporaryRoute from "./components/pages/TemporatyRoute/index";
import SheduleRoute from "./components/pages/ScheduleEventRoute/index";
import ViewOrganisation from "./components/Admin/ViewOrganisation";
import EventOrganisation from "./components/Admin/EventHost/index";
import EventsTab from "./components/Admin/ViewEvents/EventsTab";
import TabEventDetails from "./components/Admin/EventDetails/index";
import AdminViewHost from "./components/Admin/EventHost/component/index";
import ViewMappedEvents from "./components/Admin/EventHost/component/ViewEvents";
/* Organisation */
import ProfileParent from "./components/Organisation/MyProfile/components/Parent";
import Profile from "./components/Organisation/MyProfile/index";
import ChangePassword from "./components/Organisation/MyProfile/ChangePassword";
/* Host */
import CreateHost from "./components/Organisation/CreateHost";
import HostViewOrganisation from "./components/Organisation/EventHostTable/component/ViewOrganisation";
import ViewHost from "./components/Organisation/EventHostTable/ViewHost";
import ModifyHost from "./components/Organisation/EventHostTable/component/ModifyHost";
import AdminChangePassword from "./components/pages/ChangePassword";
import ViewEvents from "./components/Organisation/EventHostTable/ViewEvents";
import Downloads from "./components/internal/Downloads";
import MappedOrg from "./components/internal/Downloads/components/MappedOrg";
import DownloadDocument from "./components/internal/Downloads/components/Downloads";
/* Events */
import CreateEvent from "./components/EventCreation/CreateEvent";
import TabIndex from "./components/Events/ViewEvents/EventsTab";
import EventDetails from "./components/Events/EventDetails";
import ModifyEvent from "./components/EventCreation/ModifyEvent";
/* Viewer */
import SpotLogin from "./components/Viewer/SpotLogin/index";
// import PriorRegister from "./components/Viewer/RegisterLogin/index";
import ViewerDashboard from "./components/Viewer/ViewerDashboard/Dashboard";
import Register from "./components/Viewer/RegisterEvent";
// import JoinEvent from "./components/Viewer/JoinEvent/Join";
import OngoingEvent from "./components/Events/ViewEvents/component/Ongoing";
import AdminOngoingEvent from "./components/Admin/ViewEvents/component/Ongoing";
import PriorSignIn from "./components/Viewer/PriorSignIn";

/* Host */

import HostRoute from "./components/pages/TemporatyRoute/index";
// import HostOngoing from "./components/Host/Ongoing";
// import PastEvents from "./components/Host/Past";
// import UpcomingEvents from "./components/Host/Upcoming";
import HostTabIndex from "./components/Host/Events/EventsTab";
import HostProfile from "./components/Host/MyProfile";
import HostChangePassword from "./components/Host/MyProfile/ChangePassword";

import ResetPassword from "./components/pages/ResetPassword";
import ForgotPassword from "./components/pages/ForgotPassword";
import UserAccessRegistration from "./components/schedules/FormSettings/UserAccessRegistration";
import CustomFiledManagement from "./components/schedules/FormSettings/CustomFiledAddition";
import EventSettings from "./components/schedules/EventSettings";
import General from "./components/schedules/General";
import ThemeSettings from "./components/schedules/ThemeSettings";
import Speakers from "./components/schedules/Speakers";
import Resources from "./components/schedules/Resources";
import EmailTemplates from "./components/schedules/EmailTemplates";
import Tabs from "./components/schedules/AdditionalTabs";
import Communicate from "./components/schedules/Communicate";
import Tickers from "./components/schedules/Tickers";
import Polling from "./components/schedules/Polling";
import Reports from "./components/schedules/Reports";
import ReportsTwo from "./components/schedules/CustomTable/ReporstTwo";
import ReportsThree from "./components/schedules/CustomTable/ReportsThree";
import Home from "./components/schedules/Home/index";
import Feedback from "./components/schedules/Feedback/index";
import RegisterPage from "./components/schedules/RegistrationPage";
import SafeHarbor from "./components/schedules/SafeHarbor";
import QandADashboard from "./components/schedules/QandADashboard";
import CustomLogin from "./components/schedules/Login/index";
import CustomRegister from "./components/schedules/Register";
import WelcomeDashboard from "./components/schedules/ViewDashboard";
import LiveEvent from "./components/schedules/LiveEvent";
import ViewerHeader from "./components/schedules/ViewerRoute";
import LiveFeedback from "./components/schedules/Liveresources/Feedback";
import Preview from "./components/schedules/PreviewModal";
import ViewHostEvents from "./components/Host";
import ViewerSafeHarbor from "./components/schedules/Liveresources/SafeHarbor";
import GalleryViewRegister from "./components/GalleryView/Register";
import GalleryViewLive from "./components/GalleryView/LiveEvent";
import GalleryViewRoute from "./components/GalleryView/GalleryViewRoute";
import AgmLive from "./components/GalleryView/Agm";
import FAQs from "./components/schedules/Faqs";
import Help from "./components/schedules/Help";
import PublicAgmRoute from "./components/schedules/PublicAgmRoute/index";
const AppRouter = () => {
  const role = localStorage.getItem("role");
  return (
    <Router>
      <NotFoundPage default />
      <NotFoundPage
        errorCode="Error Code : 500"
        errorMessage="The server encountered an internal error or misconfiguration and was unable to complete your request."
        path="/internal-error"
        url="/"
      />
      <NotFoundPage
        errorCode="Error Code : 401"
        errorMessage="You do not have the permission to view the pages"
        path="/un-authorized"
        url="/"
        buttonLabel="Go to Sign"
      />
      <LoginPath path="/">
        <NotFoundPage
          default
          errorCode="Error Code : 401"
          buttonLabel={"Go to Signin"}
        />
        <LoginPage path="/" />
        <WelcomeDashboard path="/home" />
      </LoginPath>
      <ResetPassword path="reset-password/:resetToken" />
      <ForgotPassword path="forgot-password" />

      <DashboardScreens path="/dashboard">
        {/* Admin Route */}
        <DashBoardRoute
          path="/"
          selectedItem={labels.dashboard}
          selectedSubItem={labels.dashboard}
        >
          <NotFoundPage default />
          <MyDashboard path="/" breadcrumbs={["Dashboard"]} />
          <AdminChangePassword path="/change-password" />
        </DashBoardRoute>

        <EventManagerRoute
          path="/event-manager"
          selectedItem={labels.event_manager}
          selectedSubItem={labels.create_event_manager}
        >
          <NotFoundPage default />
          <CreateEventManager path="/" />
          <CreateEventManager path="/create-event" />
        </EventManagerRoute>
        <EventManagerRoute
          path="/event-manager/modify"
          selectedItem={labels.event_manager}
          selectedSubItem={labels.modify_event_manager}
        >
          <NotFoundPage default />
          <ModifyEventManager path="/" />
          <UpdateEventManager path="/:id" />
        </EventManagerRoute>
        <EventHostRoute
          path="/view-organisation"
          selectedItem={labels.view_organisation}
          selectedSubItem={labels.view_organisation}
        >
          <NotFoundPage default />
          <ViewOrganisation path="/" />
        </EventHostRoute>
        <EventHostRoute
          path="/event-host"
          selectedItem={labels.event_host}
          selectedSubItem={labels.event_host}
        >
          <NotFoundPage default />
          <EventOrganisation path="/" />
          <AdminViewHost path="/view-hosts" />
          <ViewMappedEvents path="/view-hosts/view-events" />
        </EventHostRoute>
        <EventsRoute
          path="/events"
          selectedItem={labels.events}
          selectedSubItem={labels.events}
        >
          <NotFoundPage default />
          <EventsTab path="/" />
          <TabEventDetails path="/:id" />
          <AdminOngoingEvent path="/ongoing/:id" />
        </EventsRoute>
        <AnalyticsRoute
          path="/analytics"
          selectedItem={labels.analytics}
          selectedSubItem={labels.analytics}
        >
          <NotFoundPage default />
          <EventHostTable path="/" />
        </AnalyticsRoute>
        {/* EventManager Route */}

        <ProfileParent path="/profile">
          <NotFoundPage default />
          <Profile path="/" />
          <ChangePassword path="/change-password" />
        </ProfileParent>
        <SheduleRoute path="/eventmanager" selectedItem={labels.home}>
          <NotFoundPage default />
          <MyDashboard path="/" breadcrumbs={["Dashboard"]} />
          <CreateOrganisation path="/organisation" />
          <CreateOrganisation path="/organisation/create-organisation" />
          <OrganisationTable path="/organisation/view-organisation" />
          <UpdateOrganization path="/organisation/view-organisation/:id" />
          <CreateHost path="/event-host" />
          <CreateHost path="/event-host/create-event-host" />
          <HostViewOrganisation path="/event-hosts/view-event-host" />
          <ViewEvents path="/event-hosts/view-events" />
          <ViewHost path="/event-hosts/view-hosts" />
          <ModifyHost path="/event-hosts/view-hosts/:id" />
          <CreateEvent path="/events" />
          <CreateEvent path="/events/create-events" />
          <TabIndex path="/events/view-events" />
          <EventDetails path="/events/view-events/:id" />
          <OngoingEvent path="/events/view-events/ongoing/:id" />
          <ModifyEvent path="/events/view-events/modify-event/:id" />
          <Home path="/home" />
          <QandADashboard path="/question-and-answer" />
          <QandADashboard path="/question-and-answer/:id" />
          <General path="/event-details" />
          <General path="/event-details/:id" />
          <UserAccessRegistration path="/form-settings" />
          <UserAccessRegistration path="/form-settings/:id" />
          <UserAccessRegistration path="/form-settings/user-access-registration" />
          <UserAccessRegistration path="/form-settings/user-access-registration/:id" />
          <CustomFiledManagement path="/form-settings/custom-filed-addition" />
          <CustomFiledManagement path="/form-settings/custom-filed-addition/:id" />
          <EventSettings path="/event-settings" />
          <EventSettings path="/event-settings/:id" />
          <ThemeSettings path="/theme-settings" />
          <ThemeSettings path="/theme-settings/:id" />
          <Speakers path="/speakers" />
          <Speakers path="/speakers/:id" />
          <Resources path="/resources" />
          <Resources path="/resources/:id" />
          <SafeHarbor path="/safe-harbor" />
          <SafeHarbor path="/safe-harbor/:id" />
          <Tabs path="/additional-tabs" />
          <Tabs path="/additional-tabs/:id" />
          <EmailTemplates path="/email-templates" />
          <EmailTemplates path="/email-templates/:id" />
          <Feedback path="/feedback" />
          <Feedback path="/feedback/:id" />
          <Communicate path="/communicate" />
          <Communicate path="/communicate/:id" />
          <Polling path="/polling" />
          <Polling path="/polling/:id" />
          <FAQs path="/faqs" />
          <FAQs path="/faqs/:id" />
          <Help path="/help" />
          <Help path="/help/:id" />
          <Tickers path="/tickers" />
          <Tickers path="/tickers/:id" />
          <Preview path="/preview" />
          <Preview path="/preview/:id" />
          <Reports path="/reports" />
          <Home path="/reports-dashboard" />
          <ReportsTwo path="/reports-manage-events" />
          <ReportsThree path="/reports-manage-roles" />
          <RegisterPage path="/registration-page" />
          <Downloads path="/downloads" />
          <MappedOrg path="/downloads/mapped-org" />
          <DownloadDocument path="/downloads/mapped-org/:eventId" />
        </SheduleRoute>

        {/* Host Route  */}

        <HostRoute path="/host" selectedItem={"dashboard"}>
          <NotFoundPage default />
          {/* <MyDashboard path="/" breadcrumbs={["Dashboard"]} /> */}
          <QandADashboard path="/" />
          <HostProfile path="/profile" />
          <HostChangePassword path="/change-password" />
        </HostRoute>
        <HostRoute path="/host/events" selectedItem={labels["host-events"]}>
          <NotFoundPage default />
          <ViewHostEvents path="/" />
          <QandADashboard path="/:id" />
          <HostTabIndex path="/tab" />
        </HostRoute>
      </DashboardScreens>
      <SpotLogin path="/spotlogin/:orgId/:eventId?customisedSignIn" />
      <ViewerDashboard path="/priorRegister/:orgId/:eventId?customisedSignIn" />
      <Register path="/priorRegister/register" />
      <PriorSignIn path="/priorRegister/sign-in" />
      <CustomRegister path="/events/register" />
      <CustomLogin path="/events/login" />
      <GalleryViewRegister path="/events/gallery" />
      <PublicAgmRoute path="/events/agm-live">
        <AgmLive path="/" />
      </PublicAgmRoute>
      {/* <AgmLive path="/events/agm-live" /> */}
      {/* {(role !== "host" || role !== "eventManager" || role !== "admin") && (
        <DashboardScreens path="/viewer">
          <ViewerRoute path="/">
            <NotFoundPage default />
            <JoinEvent path="/" />
          </ViewerRoute>
        </DashboardScreens>
      )} */}
      <ViewerSafeHarbor path="/safe-harbor" />
      {(role !== "host" && role !== "eventManager" && role !== "admin") && (
        <DashboardScreens path="/live">
          <ViewerHeader path="/">
            <NotFoundPage default />
            <LiveEvent path="/" />
            <LiveFeedback path="/feedback" />
          </ViewerHeader>
        </DashboardScreens>
      )}

      { (role !== "host" && role !== "eventManager" && role !== "admin") && (
        <DashboardScreens path="/gallery-viewer-live">
          <GalleryViewRoute path="/">
            <NotFoundPage default />
            <GalleryViewLive path="/" />
          </GalleryViewRoute>
        </DashboardScreens>
      )}
    </Router>
  );
};

export default AppRouter;
